export const PageLoad = {
  "pageName": "",
  "pageTitle": "",
  "pageURL": "",
  "pageCategory": "",
  "hostname": "",
  "referringURL": "",
  "breadCrumbs": "",
  "pageType": "",
  "CompanyName": "",
  "SoldTo": "",
  "siteCountry": "",
  "sitelanguage": "",
  "deviceOS": "",
  "deviceType": "",
  "environment": "",
  "prevPage": "",
  "visitorType": "",
  "pageLoadTime": "",
  "SearchTerm": "",
  "SearchResults": "",
  "contentHierarchy": {
    "level1": "",
    "level2": "",
    "level3": "",
    "level4": "",
    "level5": "",
  }
};